import logo from "../images/EssilorLuxotticaLogo.svg";
import Icon from "../components/icon";

const ForgotPassword = ({ setForgotPw, labels }) => {
  return (
    <main className="login forgot-password">
      <div className="forgot-password__back">
        <button onClick={() => setForgotPw(false)} className="link">
          <Icon name="angle-down" /> {labels?.BACK_TO_LOGIN}
        </button>
      </div>
      <div className="forgot-password__container">
        <div className="forgot-password__box">
          <img
            className="login__logo"
            src={logo}
            alt="EssilorLuxottica"
            role="heading"
            aria-level="1"
          />
          <div className="forgot-password__info">
            <h2 className="forgot-password__title" data-label="LOGIN_AND_PASSWORD_SUPPORT">
              {labels?.LOGIN_AND_PASSWORD_SUPPORT || "Login and password support"}
            </h2>
            <div
              className="forgot-password__text"
              data-label="FORGOT_PASSWORD_TEXT"
              dangerouslySetInnerHTML={{
                __html:
                  labels?.FORGOT_PASSWORD_TEXT ||
                  "Use your corporate credentials to login into EssilorLuxottica Intranet.</br>We are working to provide all users with a Microsoft Office 365 account.",
              }}
            />
            <div className="forgot-password__cards-wrapper">
              <div className="forgot-password__card">
                <div className="forgot-password__card-header">
                  <div
                    className="forgot-password__card-name"
                    data-label="FORMER_LUXOTTICA"
                    dangerouslySetInnerHTML={{
                      __html: labels?.FORMER_LUXOTTICA,
                    }}
                  />
                  <div
                    data-label="FORMER_LUXOTTICA_DESCRIPTION"
                    className="forgot-password__card-description"
                    dangerouslySetInnerHTML={{
                      __html: labels?.FORMER_LUXOTTICA_DESCRIPTION,
                    }}
                  />
                </div>
                <a
                  href="https://account.luxottica.com/password/?returnURL=https%3A%2F%2Flogon.luxottica.com%2Fnidp%2Fapp%2Flogin"
                  target="_blank"
                  rel="noreferrer"
                  className="forgot-password__label cta-link"
                  data-label="FORGOT_PASSWORD"
                >
                  {labels?.FORGOT_YOUR_MICROSOFT_PASSWORD || "FORGOT YOUR PASSWORD?"}
                </a>
              </div>
              <div className="forgot-password__card">
                <div className="forgot-password__card-header">
                  <div
                    className="forgot-password__card-name"
                    data-label="FORMER_ESSILOR"
                    dangerouslySetInnerHTML={{
                      __html: labels?.FORMER_ESSILOR,
                    }}
                  />
                  <div
                    data-label="FORMER_LUXOTTICA_DESCRIPTION"
                    className="forgot-password__card-description"
                    dangerouslySetInnerHTML={{
                      __html: labels?.FORMER_LUXOTTICA_DESCRIPTION,
                    }}
                  />
                  <a
                    href="https://account.luxottica.com/password/?returnURL=https%3A%2F%2Flogon.luxottica.com%2Fnidp%2Fapp%2Flogin"
                    target="_blank"
                    rel="noreferrer"
                    className="forgot-password__label cta-link"
                    data-label="FORGOT_PASSWORD"
                  >
                    {labels?.FORGOT_YOUR_MICROSOFT_PASSWORD || "FORGOT YOUR PASSWORD?"}
                  </a>
                  <div
                    data-label="FORMER_ESSILOR_DESCRIPTION"
                    className="forgot-password__card-description"
                    dangerouslySetInnerHTML={{
                      __html: labels?.FORMER_ESSILOR_DESCRIPTION,
                    }}
                  />
                </div>
                <a
                  href="https://accounts.google.com/signin/v2/recoveryidentifier?flowName=GlifWebSignIn&flowEntry=AccountRecovery"
                  target="_blank"
                  rel="noreferrer"
                  className="forgot-password__label cta-link"
                  data-label="FORGOT_PASSWORD"
                >
                  {labels?.FORGOT_YOUR_GOOGLE_PASSWORD || "FORGOT YOUR PASSWORD?"}
                </a>
              </div>
            </div>
            <div
              className="forgot-password__footer"
              data-label="FURTHER_HELP"
              dangerouslySetInnerHTML={{
                __html:
                  labels?.FURTHER_HELP ||
                  `If you need further help, please <a href="mailto:internal.communications@essilorluxottica.com">contact us</a>.`,
              }}
            />
          </div>
        </div>
      </div>
    </main>
  );
};

export default ForgotPassword;
